import type { Interval } from 'components/types';
import { formatByLocale } from 'utils/date';

export const getIntervalTitle = ({ startDate, endDate }: Interval) => {
  const startYear = formatByLocale(startDate, 'y');
  const endYear = formatByLocale(endDate, 'y');
  const startDateFormat = startYear === endYear ? 'd MMMM' : 'd MMMM y';
  const endDateFormat = startYear === endYear ? 'd MMMM, y' : 'd MMMM y';

  return `${formatByLocale(startDate, startDateFormat)} - ${formatByLocale(
    endDate,
    endDateFormat
  )}`;
};
